/**
 * This file is the entry point for the client-side rendering of the app.
 * We inject necessary scripts, styles, and data into the DOM here.
 */

import {createRoot} from 'react-dom/client';
import {App} from 'foundation/App';
import {getSerialized} from 'utilities/server-data';

const url = new URL(window.location.href);
const data = getSerialized();

const container = document.getElementById('app')!;
container.style.height = '100%';

if (container) {
  createRoot(container).render(<App data={data} url={url} />);
}
